module.exports = __webpack_public_path__ + "media/images/countrysquared/gy-e19e7c9d3c0ff49e28c7d90fb81f3fd1.svg";